export { default } from './CoreLayout';
